import React, {Component} from "react";
import Language from "./pages/Language";
import Page from "../../components/Page";
import { clearScidCookie } from '../../utils/scid';

class Guide extends Component{
    componentDidMount() {
        clearScidCookie();
    }

    render(){
        return (
           <Page>
               <Language/>
           </Page>
        );
    }
}

export default Guide;
